
import { connectRouter } from 'connected-react-router/immutable';
import { History } from 'history';
import { combineReducers } from 'redux-immutable';
import { reducer as oidcReducer } from 'redux-oidc';
import Account from './account.reducer';
import Article from './article.reducer';
import Auth from './auth.reducer';
import Campaign from './campaign.reducer';
import CampaignUser from './campaignUser.reducer';
import Data from './data.reducer';
import Notification from './notification.reducer';
import Organisations from './organisation.reducer';
import Roles from './roles.reducer';
import SavedSearch from './savedSearch.reducer';
import ScoutAI from './scoutAI.reducer';
import Sector from './sector.reducer';
import SeerDemo from './seerDemo.reducer';
import SubscriptionPlans from './subscriptionPlan.reducer';
import Subscriptions from './subscriptions.reducer';
import TaasConfig from './taas.reducer';
import TableState from './table.reducer';
import TargetList from './targetList.reducer';
import Users from './users.reducer';
import NerdTraining from './nerdTraining.reducer';
import Company from './company.reducer';
import SubscriptionPlanAssignee from './subscriptionPlanAssignee.reducer';
import KeyDev from './keydev.reducer';

export const allReducers = {
  Account,
  Article,
  Auth,
  Campaign,
  CampaignUser,
  KeyDev,
  Data,
  Notification,
  Organisations,
  Roles,
  SavedSearch,
  ScoutAI,
  Sector,
  SeerDemo,
  SubscriptionPlans,
  Subscriptions,
  TaasConfig,
  TableState,
  TargetList,
  Users,
  Oidc: oidcReducer,
  NerdTraining,
  Company,
  SubscriptionPlanAssignee
};

export const rootReducer = (history: History) => combineReducers({
  ...allReducers,
  router: connectRouter(history)
});
